import { Typography, TypographyProps } from '@mui/material'
import React, { ReactNode } from 'react'

type Props = Omit<TypographyProps, 'variant'> & {
  children: ReactNode
}

export const HeadlineS: React.FC<Props> = ({
  sx,
  children,
  ...typographyProps
}) => (
  <Typography
    variant="h3"
    {...typographyProps}
    sx={{
      ...sx,
      fontWeight: 'bold',
    }}
  >
    {children}
  </Typography>
)
